import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {FC} from "react";
import {useTranslation} from "react-i18next";

interface Props {
    colSpan: number
}

const EmptyRow: FC<Props> = (props) => {
    const {t} = useTranslation()

    return (
        <TableRow>
            <TableCell colSpan={props.colSpan}
                       align='center'>
                {t('no_data')}
            </TableCell>
        </TableRow>
    )
}

export default EmptyRow